module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_TPU HOT MELT FILM_deskstop.a751a5de.jpg";